import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Püsikliendile kuni

  <span style="color:#85c1dc;">**FI:**</span>
  ON24-asiakkaalle alkaen

  <span style="color:#85c1dc;">**RU:**</span>
  Для постоянного клиента до
*/
/* @__NO_SIDE_EFFECTS__ */
const m1213 = msg(
  mf`Püsikliendile kuni`,
  mf`ON24-asiakkaalle alkaen`,
  mf`Для постоянного клиента до`,
)

export { m1213 as 'w.basket.summary.customer_price' }